import { z } from 'zod';

export const zodDeliveryNoteEndpointSchema = z.tuple([
  z.literal('vadmin'),
  z.literal('asset'),
  z.literal('delivery_note'),
  z.uuid(),
]);
